// function debounce(fn, wait) {
//   let t;
//   return (...args) => {
//     clearTimeout(t);
//     t = setTimeout(() => fn.apply(this, args), wait);
//   };
// }


// customElements.define('load-more', class LoadMore extends HTMLElement {
//   constructor() {
//     super();
//     this.container = document.querySelector('[id^="ajaxinate-"]');
//     this.loadBtn = this.querySelector('[id^="load-more-"]');
//     this.loaderText = this.querySelector('.load-text');
//     // this.loaderAnim = this.querySelector('.load-anim');
    
// 	/*
// 	// with debounce
//     this.loadBtn.addEventListener('click', debounce((event) => {
//       this.onClick(event);
//     }, 300).bind(this))	
// 	*/
	
// 	// without debounce
// 	this.loadBtn.addEventListener('click', this.onClick.bind(this));

// 	// infinite scroll without click / intersection observer
// 	// this.init();
//   }

// //   init() {
// //     const observer = new IntersectionObserver(entries => {
// //       entries.forEach(item => {
// //         if(item.isIntersecting) {
// //           this.onClick();
// //           console.log("is visible")
// //         }
// //       })
// //     });
// //     observer.observe(this)
// //   }

//   onClick(event) {
//     event.preventDefault();
//     fetch(this.loadBtn.getAttribute('data-url'))
//       .then((response) => response.text())
//       .then((responseText) => {
//         this.loading();
        
//         const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');         
//         this.setInnerHTML(this.container, responseHTML.querySelector('[id^="ajaxinate-"]').innerHTML);
//         if(!responseHTML.querySelector('[id^="load-more-"]')) return this.remove();
        
//         this.loadBtn.setAttribute('data-url', responseHTML.querySelector('[id^="load-more-"]').getAttribute('data-url'));
        
//         this.clearLoading();
//       })
//       .catch(err => {
//         this.loading.classList.add('loading');
//         console.log(err)
//       });
//   }
  
//   loading() {
//     this.loadBtn.classList.add('loading');
//   }
  
//   clearLoading() {    
//     this.loadBtn.classList.remove('loading');
//   }

//   setInnerHTML(element, html) {
//     element.insertAdjacentHTML('beforeend', html);

//     // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//     element.querySelectorAll('script').forEach(oldScriptTag => {
//       const newScriptTag = document.createElement('script');
//       Array.from(oldScriptTag.attributes).forEach(attribute => {
//         newScriptTag.setAttribute(attribute.name, attribute.value)
//       });
//       newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//       oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//     });
//   }

// });


function debounce(fn, wait) {
  let timer;

  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

customElements.define(
  'load-more',
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.container = document.querySelector('[id^="ajaxinate-"]');
      this.loadBtn = this.querySelector('[id^="load-more-"]');
      this.loaderText = this.querySelector('.load-text');

      this.isLoading = false;

      this.loadBtn.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      event.preventDefault();

      if (this.isLoading) return;

      this.isLoading = true;
      this.loading();

      fetch(this.loadBtn.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newContent = doc.querySelector('[id^="ajaxinate-"]');
          const nextButton = doc.querySelector('[id^="load-more-"]');

          this.setInnerHTML(this.container, newContent.innerHTML);

          if (!nextButton) {
            this.remove();
            return;
          }

          this.loadBtn.dataset.url = nextButton.dataset.url;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;

          if (this.isConnected) {
            this.clearLoading();
          }
        });
    }

    loading() {
      this.loadBtn.classList.add('loading');
      this.loadBtn.setAttribute('aria-busy', 'true');
      this.loadBtn.setAttribute('aria-disabled', 'true');

      if (this.loaderText) {
        this.loaderText.textContent = 'Loading...';
      }
    }

    clearLoading() {
      this.loadBtn.classList.remove('loading');
      this.loadBtn.setAttribute('aria-busy', 'false');
      this.loadBtn.removeAttribute('aria-disabled');

      if (this.loaderText) {
        this.loaderText.textContent = 'Load More';
      }
    }

    setInnerHTML(element, html) {
      element.insertAdjacentHTML('beforeend', html);

      element.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');

        [...oldScript.attributes].forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });

        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });
    }
  }
);